export enum ProviderLoadStateOption {
    Loaded,
    Loading,
    NotLoaded,
}
